import { NavigationHeader } from '@atbay/cyber-components'
import { styled } from '@mui/system'

// TODO: remove this CSS clamp once cyber-components' NavigationHeader supports a
// native two-line title prop, and pass that prop instead.
export const multilineTitleClamp = `
    white-space: normal;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
`

export const HeaderRefWrapper = styled('div')`
    display: contents;
`

export const MetaSlot = styled('div')`
    padding-left: 61px; /* 45px icon + 16px header-row gap → aligns under title text */
    margin-top: 8px;
`

export const StyledNavigationHeader = styled(NavigationHeader)`
    .cc-drawer-nav-icon {
        width: 45px;
        height: 45px;
    }

    .cc-drawer-nav-title-block {
        gap: 6px;
    }

    .cc-drawer-nav-title {
        ${multilineTitleClamp}
        font-size: 18px;
        line-height: 22px;
    }
`
